import coreMiddlewares from '../modules/core/middlewares';
import dokbotMiddlewares from '../modules/dokbot/middlewares';
import locations from '../modules/settings/tabs/clinic-settings/locations';
export const middlewares = [
    ...coreMiddlewares,
    ...dokbotMiddlewares,
    locations.middleware.locationsLoader,
];
export default middlewares;
